import { style } from '@vanilla-extract/css'

const content = style({
  position: 'relative',
  borderRadius: '40px !important', // Radix UIのスタイルを上書き
})

const close = style({
  position: 'fixed',
  top: '10px',
  right: '16px',
  cursor: 'pointer',
});

export const styles = {
  content,
  close,
}
